module.exports = __webpack_public_path__ + "img/malahini-because.fd5c0ba3.jpg";